// extracted by mini-css-extract-plugin
module.exports = {"cardSkeleton":"_2JLnJ","carImage":"_3ACK3","price":"_1mcKN","greyBar":"_2081Z"};